import { memo } from "react";
import UnarriveReason from "./UnarriveReason";
import Tooltip from "../../../common/StyledToolTip";

const getTooltipTitle = (unarrivedReason) => {
  if (unarrivedReason?.description) return `Unarrived (${unarrivedReason.description})`;
  if (unarrivedReason?.code) return `Unarrived (${unarrivedReason.code})`;
  return 'Unarrived';
};

const UnarriveIndicator = ({ color, size = 14, unarrivedReason, className }) => {
  return (
    <Tooltip title={getTooltipTitle(unarrivedReason)}>
      <span className={className}>
        <UnarriveReason color={color} size={size} />
      </span>
    </Tooltip>
  );
};

export default memo(UnarriveIndicator);
